module.exports = __webpack_public_path__ + "img/border_edge_shape.764093f4.svg";